import AxiosJob from '@/services/api/job/axios_job'

export default {
  createPoolACL: (data) => {
    return AxiosJob.post('pool-acl', data)
  },

  updatePoolACL: (poolAclId, data) => {
    return AxiosJob.put(`pool-acl/${poolAclId}`, data)
  },

  getPoolACLsFromUserGroup: (params) => {
    return AxiosJob.get(`pool-acl/user-group`, { params })
  },

  getPoolACLsFromPool: (poolId, params) => {
    return AxiosJob.get(`pool-acl/pool/${poolId}`, { params })
  },

  getPoolACL: (poolAclId) => {
    return AxiosJob.get(`pool-acl/${poolAclId}`)
  },

  deletePoolACL: (poolAclId) => {
    return AxiosJob.delete(`pool-acl/${poolAclId}`)
  }
}
